import * as React from 'react';

import Grid from '@mui/material/Grid';

import { CARDS } from '../constants';
import { KPICard } from './index';

function KPISection() {
  return (
    <Grid
      className={'home_page__kpi-section-container'}
      container={true}
      justifyContent={'center'}
      spacing={3}
    >
      <Grid item={true} xs={10} lg={8} className={'home_page__kpi-cards-title-container'}>
        <h2 id={'home-page__kpi-section-title'}>
          Players love the experience. Creators love the results.
        </h2>
        <h3 id={'home-page__kpi-section-description'}>
          The thrill of competition keeps players engaged day after day. Partner with Skillz and
          generate market-leading returns.
        </h3>
      </Grid>

      <Grid item={true} xs={10} lg={8} className={'home_page__kpi-cards-container'}>
        <KPICard id={'home-page__card-blue'} cardInfo={CARDS.blue} />
        <KPICard id={'home-page__card-green'} cardInfo={CARDS.green} />
        <KPICard id={'home-page__card-purple'} cardInfo={CARDS.purple} />
      </Grid>
    </Grid>
  );
}

export { KPISection };
